import React, { useEffect, useState } from "react";
import { lifestyleApi } from "../apiService/api";

const UpcomingSession = () => {
  const [sessions, setSessions] = useState([]);

  useEffect(() => {
    lifestyleApi.counsellorSession()
      .then((res) => setSessions(res.data.data || []))
      .catch((err) => console.error("counsellorSession:", err));
  }, []);

  return (
    <section className="sessions-bg">
      {sessions.map((session, index) =>
        session.unlocked === "Y" ? (
          <a key={index} href={session.url} className="session-link">
            <div className="session-card session-unlocked">
              <span className="session-name">{session.sessionName}</span>
              <button className="session-play-btn">&#9658;</button>
            </div>
          </a>
        ) : (
          <div key={index} className="session-card session-locked">
            <div>
              <span className="session-name">{session.sessionName}</span>
              <span className="session-time">{session.unlockTime}</span>
            </div>
            <button className="session-lock-btn" disabled>&#128274;</button>
          </div>
        )
      )}
    </section>
  );
};

export default UpcomingSession;
